<template>
	<div class="home">		
		<img src="../assets/make-a-wish-logo.png" alt="" class="make-a-wish-logo">
		<div class="script-pad">
			<h2>Happy new year 2020</h2>

			<p>บ้านจีบันอยากชวนทุกคนมา Make A Wish <br m>ตั้งเป้าหมายท้าทายปี 2020 กัน! </p>
			<p>ความฝัน 5 อย่าง <br m>ที่อยากให้เป็นจริงในปีนี้ของคุณมีอะไรบ้าง?  <br m>ไม่ว่าจะเป็นเรื่องงาน เงิน สุขภาพ  <br m>หรือไอเท็มบิวตี้ที่อยากได้<br m><br>แล้วถ้าทำสำเร็จจะให้อะไรเป็นรางวัลตัวเอง? </p>
			<p>เป้าหมายของเรา อาจจะเป็นแรงบันดาลใจ<br m>ให้เพื่อนๆ อีกหลายคนก็ได้นะ :D<br>จบปีนี้มาดูกันว่าความฝันไหนจะเป็นจริง </p>

			<router-link v-if="totalWish == 0" to="/new" class="add-more-wish">เริ่ม Make A Wish เลย</router-link>
			<router-link v-else-if="totalWish < 5" to="/new" class="add-more-wish">Add More Wish</router-link>
			<a v-else disabled class="add-more-wish">เริ่ม Make A Wish เลย</a>
		</div>

		<wish-board></wish-board>

		<my-avatar-floating v-if="isAuthenticated && myWishes.length" :user="user"></my-avatar-floating>
	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import WishBoard from '@/components/WishBoard.vue'

	export default {
		name: 'home',
		components: {
			WishBoard,
			MyAvatarFloating: () => import('@/components/MyAvatarFloating.vue')
		},
		data () {
			return {
				myWishes: [],
				myReward: null
			}
		},
		computed: {
			isAuthenticated () {
				return this.$store.getters.isAuthenticated
			},
			user () {
				return this.$store.getters.user
			},
			totalWish () {
				return (typeof this.myWishes === 'undefined') ? 0 : this.myWishes.length
			}
		},
		methods: {
			getMyWishes (callback) {
				Promise.all([
						window.axios.get(`${config.BASE_URL}/wish/2020`),
						window.axios.get(`${config.BASE_URL}/wish/2020/reward`),
					])
					.then(responses => {
						if (responses[0].data.code === 0) {
							this.myWishes = responses[0].data.data.wishList
						}
						if (responses[1].data.code === 0) {
							this.myReward = responses[1].data.data
						}
					})
					.catch(error => {
						this.$store.commit(types.SET_ERROR_MSG, error)
					})
			},			
		},
		mounted () {
	    	if (!this.$store.getters.isInitted) {
		    	this.$store.dispatch('initAuthUser')
					.then(() => {
						this.getMyWishes()
					})
	    	} else {
	    		this.getMyWishes()
	    	}
		}
	}
</script>

<style lang="scss">
	.home {
		min-height: 100vh;
		box-sizing: border-box;
		
		background: url('../assets/bg-2020.png') #064D81 no-repeat;
		background-position-x: calc(50% + 60px);
		background-position-y: -259px;
		background-size: 1703.66px auto;

		@media (max-width: 767px) {
			background-image: url('../assets/bg-2020-xs.png');
			background-position-x: center;
			background-position-y: -177.1px;
			background-size: 566.36px auto;

			padding-top: 50px;
		}
	}
	.make-a-wish-logo {
		display: flex;
		width: 500px;
		max-width: 100%;

		margin-left: auto;
		margin-right: auto;
		
		@media (max-width: 767px) {
			width: 370px;
			margin-bottom: 56px;
		}
	}
	.script-pad {
		text-align: center;

		background: url('../assets/bg-script-pad-1.png') center top transparent repeat-y;
		background-size: 1018px auto;
		position: relative;
		padding: 1rem;

		max-width: 1018px;
		margin: 40px auto 82.5px auto;
		margin-right: auto;

		font-family: 'DB-Heavent-reg';
		font-size: 24px;

		&:before {
			background: url('../assets/bg-script-pad-0.png') center top transparent no-repeat;
			height: 73px;
			top: -72px;
		}
		&:after {
			background: url('../assets/bg-script-pad-2.png') center top transparent no-repeat;
			height: 82.5px;
			bottom: -81.5px;
		}
		&:before, &:after {
			background-size: 1018px auto;
			position: absolute;

			content: '';
			display: block;
			left: 0;
			width: 100%;

			@media (max-width: 767px) {
				background-size: 125% 100%;
			}
		}

		h2 {
			@include font-reg;
			font-size: 38px;
		}

		p {
			max-width: calc(1000px - 2rem);
			margin-left: auto;
			margin-right: auto;
			line-height: 1.2;
		}

		a.add-more-wish {
			background: #EEB85F;
			color: white;
			width: 222px;
			height: 52px;
			border-radius: 26px;

			display: flex;
			justify-content: center;
			align-items: center;

			margin: 40px auto 0;

			font-family: 'DB-Heavent-reg';
			font-size: 28px;
			text-decoration: none;
			box-shadow: 0px 3px 6px rgba(0, 0, 0, .16);

			@media (max-width: 767px) {
				margin: 24px auto 0;
			}

			&[disabled] {
				opacity: .35;
			}
		}
	}
</style>